import PeriodDisplay from "connected-components/dashboard/components/period-display"

export default function PerformanceHeader() {
  return (
    <PeriodDisplay />
  )
}
